<template>
  <div class="user-wrapper">
    <div class="content-box">
      <a class="mr-20" @click="openLeChengModel" :style="{color: lcStatus == 0 ? 'red' : 'green'}">乐橙订单凭证（{{ lcStatus == 0 ? '已过期' : '生效中' }}）</a>
      <LeChengToken ref="leChengToken" />
      <a-button v-if="$store.getters.userType == '22'" type="primary" class="mr-10" @click="goNewlyaddedOrderList">
        立即下单
      </a-button>
      <!-- <newlyadded-order-list-model ref="newlyaddedorderlist"></newlyadded-order-list-model> -->
      <a-badge
        v-if="$store.getters.userType == '00' || $store.getters.userType == '22'"
        :count="cuidanCount"
        @click="cuidanList"
      >
        <a class="mr-6">{{ $store.getters.userType == '22' ? '已完成' : '待处理' }}催单</a>
      </a-badge>
      <cuidan ref="cuidan"></cuidan>

      <a-switch
        v-if="deptId == 103 || deptId == 106"
        checked-children="在岗"
        un-checked-children="离岗"
        @click="haveworks"
        :checked="havework"
      />
      <a-switch
        checked-children="接单"
        @click="autoorders"
        v-if="havework == true && deptId == 103"
        un-checked-children="不接单"
        :checked="autoorder"
      />

      <!-- 企业的师傅查询干掉 -->
      <a-dropdown v-if="$store.getters.userType != '22'">
        <inquiryMaster style="display: inline-block"></inquiryMaster>
      </a-dropdown>
      <!-- 企业金额信息 -->
      <a-dropdown>
        <amount-enterprise style="display: inline-block"></amount-enterprise>
      </a-dropdown>
      <!-- 挂起订单 -->
      <a-dropdown v-if="$store.getters.userType != '22'">
        <holdorder style="display: inline-block"></holdorder>
      </a-dropdown>
      <!--      <a-dropdown style="margin: 0 10px 0 0">-->
      <!--<a class="action ant-dropdown-link user-dropdown-menu" @click= "Todo" >-->
      <!--待办事项-->
      <!--</a>-->

      <to-do-list style="display: inline-block"></to-do-list>
      <!--      </a-dropdown>-->
      <a-dropdown v-if="OrderStatus != 9" style="margin: 0 10px 0 0">
        <!-- <a class="action ant-dropdown-link user-dropdown-menu">
          我的账户
        </a> -->
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
          <a-menu-item key="0" @click="information">
            <a-icon type="user" />
            <span>账户信息</span>
          </a-menu-item>
          <a-menu-item key="1" @click="information2">
            <a-icon type="setting" />
            <span>在线充值</span>
          </a-menu-item>
          <a-menu-item key="2">
            <a href="javascript:;" @click="information3">
              <a-icon type="logout" />
              <span>充值列表</span>
            </a>
          </a-menu-item>
          <a-menu-item key="3">
            <a href="javascript:;" @click="information4">
              <a-icon type="logout" />
              <span>账单</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>

      <a-dropdown style="margin: 0 10px 0 0">
        <a class="action ant-dropdown-link user-dropdown-menu" @click="Downloads">我的下载</a>
      </a-dropdown>
      <a-dropdown style="margin: 0 10px 0 0">
        <customer-orders style="display: inline-block"></customer-orders>
        <!-- <a class="action ant-dropdown-link user-dropdown-menu" v-if="enterpriseId=='72620e120c3a11ef8a26fa163ec52c23'" @click= "CustomerOrders" >
          客户下单
        </a> -->
      </a-dropdown>

      <!--<a href="http://doc.rycloud.zmrit.com/#/quick-start" target="_blank">-->
      <!--<span class="action">-->
      <!--<a-icon type="question-circle-o"></a-icon>-->
      <!--</span>-->
      <!--</a>-->
      <!--<notice-icon class="action"/>-->
      <!--<lang-select />-->
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <img
            v-if="$store.state.user_type == 1"
            src="../../../public/images/loginT.png"
            alt=""
            style="width: 35px; height: 35px"
          />
          <img v-else src="@/assets/logo3.jpg" alt="" style="width: 35px; height: 35px" />
          <span>{{ nickname }}</span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
          <a-menu-item key="0" @click="handleUserinfo">
            <a-icon type="user" />
            <span>用户信息</span>
          </a-menu-item>
          <a-menu-item key="1" @click="handleMessage">
            <a-icon type="setting" />
            <span>值班技术</span>
          </a-menu-item>
          <!--<a-menu-item key="2" disabled>-->
          <!--<a-icon type="setting"/>-->
          <!--<span>测试</span>-->
          <!--</a-menu-item>-->
          <!--<a-menu-divider/>-->
          <a-menu-item key="2">
            <a href="javascript:;" @click="handleLogout">
              <a-icon type="logout" />
              <span>退出登录</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <div v-html="html1"></div>
    <!--用户信息-->
    <a-modal
      title="用户信息"
      style="top: 20px"
      v-model="visible1"
      :width="800"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit1"
      :footer="false"
      :closable="false"
      :maskClosable="false"
    >
      <a-row style="margin-bottom: 20px">
        <a-col :span="24" style="margin-bottom: 20px">
          <a-button type="primary" @click="goBack1">返回</a-button>
        </a-col>
        <a-col :span="9"></a-col>
        <a-col :span="10">
          <a-button type="primary" style="margin-right: 30px" @click="handleEdit">修改密码</a-button>
          <a-button type="primary" @click="handleLogin">最近登录</a-button>
        </a-col>
      </a-row>
      <table border="1" width="500" align="center" cellspacing="0" cellpadding="6" style="margin-bottom: 20px">
        <tr align="center">
          <th>登录名</th>
          <td>{{ queryParam.loginName }}</td>
        </tr>
        <tr align="center">
          <th>姓名</th>
          <td>{{ queryParam.userName }}</td>
        </tr>
        <tr align="center">
          <th>部门</th>
          <td>{{ queryParam.deptName }}</td>
        </tr>
        <tr align="center">
          <th>职位</th>
          <td>{{ queryParam.roleName }}</td>
        </tr>
        <tr align="center">
          <th>联系方式</th>
          <td>{{ queryParam.phonenumber }}</td>
        </tr>
        <!--<tr align="center">-->
        <!--<th>邮箱</th>-->
        <!--<td>{{queryParam.email}}</td>-->
        <!--</tr>-->
      </table>
    </a-modal>
    <!--修改密码-->
    <a-modal
      title="修改密码"
      style="top: 20px"
      :width="800"
      v-model="visible2"
      :confirmLoading="confirmLoading"
      :cancelButtonProps="{ props: { disabled: true } }"
      :closable="false"
      :maskClosable="false"
      :footer="null"
    >
      <a-form :form="form" @submit="handleSubmit2">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="原密码" has-feedback>
          <a-input
            v-decorator="['oldPwd', { rules: [{ required: true, message: '请输入原密码!' }] }]"
            type="text"
            autocomplete="off"
            onfocus="this.type='password'"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新密码" has-feedback>
          <a-input
            maxLength="20"
            v-decorator="['newPwd', { rules: [{ required: true, message: '请输入新密码!' }, { validator: checkPwd }] }]"
            type="password"
            autocomplete="off"
          />
        </a-form-item>
        <a-form-item maxLength="20" :labelCol="labelCol" :wrapperCol="wrapperCol" label="重新输入新密码" has-feedback>
          <a-input
            :min="5"
            :max="20"
            v-decorator="[
              'confirm',
              { rules: [{ required: true, message: '请重新输入新密码!' }, { validator: compareToFirstPassword }] }
            ]"
            type="password"
            autocomplete="off"
            @blur="handleConfirmBlur"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 34%">
          <a-button type="primary" style="margin-right: 20px; width: 120px" html-type="submit">提交</a-button>
          <a-button style="width: 120px" @click="goBack2">取消</a-button>
          <!--<a-button type="primary" html-type="submit">-->
          <!--Register-->
          <!--</a-button>-->
        </a-form-item>
      </a-form>
    </a-modal>
    <!--最近登录-->
    <a-modal
      title="最近登录"
      style="top: 20px"
      v-model="visible3"
      :width="800"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit3"
      :footer="false"
      :closable="false"
      :maskClosable="false"
    >
      <a-row :span="24" style="margin-bottom: 20px">
        <a-button type="primary" @click="goBack3">返回</a-button>
      </a-row>
      <a-table
        size="default"
        ref="table"
        showHeader="false"
        :data-source="data3"
        :columns="columns3"
        bordered
        :pagination="false"
      >
      </a-table>
    </a-modal>
    <!--值班技术-->
    <a-modal
      title="值班技术"
      style="top: 20px"
      v-model="visible4"
      :width="800"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit4"
      :footer="false"
      :closable="false"
      :maskClosable="false"
    >
      <a-row :span="24" style="margin-bottom: 20px">
        <a-button type="primary" @click="goBack4">返回</a-button>
        <a-button type="primary" @click="goBackAdd" v-if="disGoBackAdd" style="margin-left: 20px">新增</a-button>
      </a-row>
      <a-table size="default" ref="table" showHeader="false" :data-source="data4" :columns="columns4" bordered>
      </a-table>
    </a-modal>
    <!--值班技术新增-->
    <a-modal
      title="新增"
      style="top: 20px"
      v-model="visible19"
      :width="800"
      :closable="false"
      :maskClosable="false"
      @ok="handleSubmit11"
    >
      <a-form :form="form9">
        <a-form-item
          label="新增值班技术"
          :label-col="formItemLayout1.labelCol"
          :wrapper-col="formItemLayout1.wrapperCol"
        >
          <a-select
            mode="multiple"
            v-decorator="['technicalId', { rules: [{ required: false, message: '请选择新增值班技术' }] }]"
            @change="beOnDuty"
          >
            <a-select-option v-for="(type, index) in technicalIdArr" :key="type.technicalId" :value="type.technicalId">
              {{ type.technicalName }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <!--账户信息-->
    <a-modal
      title="账户信息"
      style="top: 20px"
      v-model="visible5"
      :width="800"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit5"
    >
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业名称">
        <a-input v-model="enterpriseName" disabled="disabled" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="钱包余额">
        <a-input v-model="totalBalance" disabled="disabled" />
      </a-form-item>
    </a-modal>

    <!--在线充值-->
    <a-modal
      title="在线充值"
      style="top: 20px"
      v-model="visible6"
      :width="800"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit6"
      :footer="false"
    >
      <a-steps :current="current" style="margin-bottom: 40px">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
      </a-steps>
      <div v-if="current == 0">
        <a-button style="margin: 20px" v-for="(list, index) in dataList" @click="changeTab(index)" :key="index">{{
          list
        }}</a-button>

        <a-form-item v-if="visible9" :labelCol="labelCol" :wrapperCol="wrapperCol" label="其他金额">
          <a-input-number style="width: 100%" :min="0" v-model="totalAmount" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应付金额">
          <a>{{ totalAmount }}元</a>
        </a-form-item>
      </div>

      <div v-if="current == 1">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应付金额">
          <a>{{ totalAmount }}</a>
        </a-form-item>

        <!--<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="充值账号">-->
        <!--<a>{{enterpriseName}}</a>-->
        <!--</a-form-item>-->

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="选择支付方式">
          <a-radio-group name="radioGroup" :default-value="1" v-model="payType" :disabled="rechargeNum == 1">
            <a-radio :value="2"> 支付宝 </a-radio>
            <a-radio :value="1"> 线下支付 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-if="payType == 2" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <div style="width: 100%; margin-left: 25px">
            <a-icon type="exclamation-circle" style="margin: 0 5px; color: #ffd700" />
            请在提交订单后30分钟内完成支付，否则订单会自动取消
          </div>
        </a-form-item>
        <a-form-item v-if="payType == 1" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <div style="margin-left: 25px">
            <div>开户名称：江苏锁安科技有限公司</div>
            <div>开户银行：招商银行南京分行雨花支行</div>
            <div>银行账号：125908208810601</div>
          </div>
        </a-form-item>
      </div>

      <div v-if="current == 2">
        <div style="width: 100%; text-align: center; margin-top: 40px; font-size: 24px">
          <p>
            <span>充值交易号: </span>
            <span>{{ orderNumber }}</span>
          </p>
          <p>充值完成！</p>
          <p>请联系财务人员确认是否充值成功</p>
        </div>
      </div>

      <div>
        <a-button v-if="current < steps.length - 1" type="primary" @click="next" style="margin: 0 25px">
          确定
        </a-button>
        <a-button v-if="current == steps.length - 1" type="primary" @click="next" style="margin: 0 25px">
          确定
        </a-button>
        <span v-if="current == 0"> 一旦充值无法提现，如果要提现请联系锁安工作人员</span>

        <!--        <a-button v-if="current > 0" style="margin-left: 8px" @click="prev">-->
        <!--          上一步-->
        <!--        </a-button>-->
      </div>
    </a-modal>

    <!--充值列表-->
    <a-modal
      title="充值列表"
      style="top: 20px"
      v-model="visible7"
      :width="900"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit7"
    >
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :span="7">
              <a-form-item label="订单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="orderNo" />
              </a-form-item>
            </a-col>
            <a-col :span="7">
              <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="payStatus">
                  <a-select-option :value="1">已支付</a-select-option>
                  <a-select-option :value="2">未支付</a-select-option>
                  <a-select-option :value="3">取消支付</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="7">
              <a-form-item label="操作日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-date-picker @change="onChangeDate" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <span class="table-page-search-submitButtons">
          <a-button type="primary" @click="query">查询</a-button>
          <a-button style="margin-left: 8px" @click="reset">重置</a-button>
        </span>
      </div>
      <a-table size="default" ref="table" showHeader="false" :data-source="data5" :columns="columns5" bordered>
        <span slot="operation" slot-scope="text, record" v-if="record.status == '未支付' && record.payType == 2">
          <a @click="handleEdit2(record)">支付</a>
          <!--<a-divider type="vertical" />-->
          <!--<a  @click="handleEdit3(record)">删除</a>-->
        </span>
      </a-table>
    </a-modal>

    <!--账单-->
    <a-modal
      title="账单列表"
      style="top: 20px"
      v-model="visible8"
      :width="800"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit8"
    >
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="16">
            <a-col :span="8">
              <a-form-item label="订单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input style="width: 150px" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="操作类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select>
                  <a-select-option value="0">充值</a-select-option>
                  <a-select-option value="1">工单类型</a-select-option>
                  <a-select-option value="2">回收站</a-select-option>
                  <a-select-option value="3">修改</a-select-option>
                  <a-select-option value="4">转单</a-select-option>
                  <a-select-option value="5">回收站恢复</a-select-option>
                  <a-select-option value="5">转单恢复</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="操作人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input style="width: 150px" />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="下单时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-date-picker @change="onChangeDate" />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="操作时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-date-picker @change="onChangeDate" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table size="default" ref="table" showHeader="false" :data-source="data6" :columns="columns6" bordered>
      </a-table>
    </a-modal>
    <!--退出-->
    <a-modal
      title="退出"
      style="top: 20px"
      v-model="visible10"
      :width="800"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit9"
    >
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="在岗状态" v-if="deptId == 103">
        <a>{{ workStatus }}</a>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="待办事项数">
        <a>{{ todoCount }}</a>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="未派单" v-if="deptId == 103">
        <a>{{ outstandOrderCount }}</a>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="今日处理工单数" v-if="deptId == 103">
        <a>{{ processedOrderCount }}</a>
      </a-form-item>
    </a-modal>

    <!--我的下载-->
    <a-modal
      title="我的下载"
      style="top: 20px"
      v-model="visible11"
      :width="1000"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit10"
    >
      <span class="table-page-search-submitButtons">
        <a-button type="primary" @click="query2">清空</a-button>
      </span>
      <a-table
        size="default"
        ref="table"
        showHeader="false"
        :data-source="data7"
        :columns="columns7"
        bordered
        :scroll="{ x: '1500px' }"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit23(record)">下载</a>
        </span>
      </a-table>
    </a-modal>
    <!--客户下单移除弹框-->
    <a-modal
      title="客户下单移除"
      style="top: 20px"
      v-model="visible13"
      :width="600"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit13"
      :destroyOnClose="true"
    >
      <a-form :form="form" @submit="handleSubmit13">
        <a-form-item label="移除原因" :label-col="formItemLayout1.labelCol" :wrapper-col="formItemLayout1.wrapperCol">
          <a-select
            v-decorator="['status', { initialValue: '', rules: [{ required: true, message: '请选择状态' }] }]"
            @change="removeState"
          >
            <a-select-option v-for="type in restaurantOperType" :key="type.code" :value="type.code">
              {{ type.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="备注" :label-col="formItemLayout1.labelCol" :wrapper-col="formItemLayout1.wrapperCol">
          <a-textarea
            v-if="removeStateNum == 3"
            style="height: 150px"
            v-decorator="['remark', { rules: [{ required: true, message: '请输入备注' }] }]"
          ></a-textarea>
          <a-textarea
            v-else
            v-decorator="['remark', { rules: [{ required: false, message: '请输入备注' }] }]"
            style="height: 150px"
            @change="remarkChange"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
    <!--客户下单-->
    <a-modal
      title="客户下单"
      style="top: 20px"
      v-model="visible12"
      :width="1400"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit12"
      :destroyOnClose="true"
    >
      <div class="table-page-search-wrapper">
        <a-form :form="form3" layout="inline">
          <a-row :gutter="16">
            <a-col :span="6">
              <a-form-item label="企业名称">
                <a-input v-model="enterpriseName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="客户姓名">
                <a-input v-model="customerName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="客户联系方式">
                <a-input v-model="customerMobile" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="客户下单时间">
                <a-range-picker
                  v-model="time"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="onChange1"
                  @ok="onOk"
                />
              </a-form-item>
            </a-col>
            <a-col :span="3">
              <a-form-item label="客户地址">
                <a-select :allowClear="true" v-decorator="['provinceId']">
                  <a-select-option
                    :value="type.provinceCode"
                    v-for="type in provinceMap"
                    :key="type.provinceCode"
                    @click="changeProvince(type.provinceCode)"
                    >{{ type.provinceName }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="2">
              <a-form-item label="">
                <a-select :allowClear="true" v-decorator="['cityId']">
                  <a-select-option
                    :value="type.cityCode"
                    v-for="type in cityMap"
                    :key="type.provinceCode"
                    @click="changeCity(type.cityCode)"
                    >{{ type.cityName }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="2">
              <a-form-item label="">
                <a-select :allowClear="true" v-decorator="['areaId']">
                  <a-select-option
                    :value="type.areaCode"
                    v-for="type in areaArr"
                    :key="type.areaCode"
                    @click="changeArea(type.areaCode)"
                    >{{ type.areaName }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="5">
              <a-form-item label="详细地址">
                <a-input v-model="detailedAddress" />
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item label="安装类别" style="margin-left: 28px">
                <a-select @change="installChange" :allowClear="true" v-model="installType">
                  <a-select-option v-for="type in installTypes" :key="type.code">{{ type.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="订单类型" style="margin-left: 28px">
                <a-select :allowClear="true" @change="orderTypeChange" v-model="orderType">
                  <a-select-option v-for="type in List" :key="type.orderTypeId">{{ type.typeName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="status == 1 || status == 2">
              <a-form-item label="处理人" style="margin-left: 14px">
                <a-input v-model="updateBy"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="status == 1 || status == 2">
              <a-form-item label="处理时间">
                <!--<a-input  v-model="updateTime"></a-input>-->
                <a-range-picker
                  v-model="updateTime"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="onChange2"
                  @ok="onOk"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="status == 1">
              <a-form-item label="订单号" style="margin-left: 42px">
                <a-input v-model="orderNo" />
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="status == 2">
              <a-form-item label="移除人" style="margin-left: 42px">
                <a-input v-model="deleteBy"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="status == 2">
              <a-form-item label="移除时间" style="margin-left: 28px">
                <!--<a-input  v-model="deleteTime"></a-input>-->
                <a-range-picker
                  v-model="deleteTime"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="onChange3"
                  @ok="onOk"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="status == 2">
              <a-form-item label="移除原因">
                <a-input v-model="deleteReason"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" :offset="19" style="text-align: right">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="queryList">查询</a-button>
                <a-button style="margin: 0 8px" @click="queryKong">清空</a-button>
                <a-button type="primary" @click="xiadanExcept">导出EXCEL</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-divider></a-divider>
      <a-tabs type="card" @change="changeTabs">
        <a-tab-pane key="1">
          <span slot="tab">
            <span>待处理 </span>
            <span style="color: red"> [{{ datalist12 }}]</span>
          </span>
          <a-table
            size="default"
            ref="table"
            showHeader="false"
            :data-source="data12"
            :columns="columns12"
            :scroll="{ x: 2000 }"
            bordered
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          >
            <span
              v-for="list in columns12"
              v-if="list.dataIndex != 'action'"
              :slot="list.dataIndex"
              slot-scope="text, record"
            >
              <a-popover>
                <template slot="content">
                  <p>
                    <span>客户姓名：</span>
                    <span>{{ record.customerName }}</span>
                  </p>
                  <p>
                    <span>客服电话：</span>
                    <span>{{ record.customerMobile }}</span>
                  </p>
                  <p>
                    <span>客户地址：</span>
                    <span>{{ record.address }}</span>
                  </p>
                  <p>
                    <span>订单类型：</span>
                    <span>{{ record.orderType }}</span>
                  </p>
                  <p>
                    <span>安装类别：</span>
                    <span>{{ record.installType }}</span>
                  </p>
                  <p v-for="item in record.infoList" v-if="item.infoValue != null">
                    <span>{{ item.infoName }}：</span>
                    <span>{{ item.infoValue }}</span>
                  </p>
                </template>
                <span type="primary">
                  {{ text }}
                </span>
              </a-popover>
            </span>
            <span v-else slot="action" slot-scope="text, record">
              <a @click="handleEdit12(record)">下单</a>
              <a-divider type="vertical" />
              <a @click="handleRemove12(record)">移除</a>
            </span>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="已处理">
          <a-table
            size="default"
            ref="table"
            showHeader="false"
            :data-source="data13"
            :columns="columns13"
            :scroll="{ x: 2000 }"
            bordered
          >
            <span
              v-for="list in columns13"
              v-if="list.dataIndex != 'action'"
              :slot="list.dataIndex"
              slot-scope="text, record"
            >
              <a-popover>
                <template slot="content">
                  <p>
                    <span>客户姓名：</span>
                    <span>{{ record.customerName }}</span>
                  </p>
                  <p>
                    <span>客服电话：</span>
                    <span>{{ record.customerMobile }}</span>
                  </p>
                  <p>
                    <span>客户地址：</span>
                    <span>{{ record.address }}</span>
                  </p>
                  <p>
                    <span>订单类型：</span>
                    <span>{{ record.orderType }}</span>
                  </p>
                  <p>
                    <span>安装类别：</span>
                    <span>{{ record.installType }}</span>
                  </p>
                  <p v-for="item in record.infoList" v-if="item.infoValue != null">
                    <span>{{ item.infoName }}：</span>
                    <span>{{ item.infoValue }}</span>
                  </p>
                </template>
                <span type="primary">
                  {{ text }}
                </span>
              </a-popover>
            </span>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="3" tab="回收站">
          <a-table
            size="default"
            ref="table"
            showHeader="false"
            :data-source="data14"
            :columns="columns14"
            :scroll="{ x: 2000 }"
            bordered
          >
            <span
              v-for="list in columns14"
              v-if="list.dataIndex != 'action'"
              :slot="list.dataIndex"
              slot-scope="text, record"
            >
              <a-popover>
                <template slot="content">
                  <p>
                    <span>客户姓名：</span>
                    <span>{{ record.customerName }}</span>
                  </p>
                  <p>
                    <span>客服电话：</span>
                    <span>{{ record.customerMobile }}</span>
                  </p>
                  <p>
                    <span>客户地址：</span>
                    <span>{{ record.address }}</span>
                  </p>
                  <p>
                    <span>订单类型：</span>
                    <span>{{ record.orderType }}</span>
                  </p>
                  <p>
                    <span>安装类别：</span>
                    <span>{{ record.installType }}</span>
                  </p>
                  <p v-for="item in record.infoList" v-if="item.infoValue != null">
                    <span>{{ item.infoName }}：</span>
                    <span>{{ item.infoValue }}</span>
                  </p>
                </template>
                <span type="primary">
                  {{ text }}
                </span>
              </a-popover>
            </span>
            <span v-else slot="action" slot-scope="text, record">
              <a @click="handleAdd14(record)">恢复</a>
            </span>
          </a-table>
        </a-tab-pane>
        <a-button type="primary" slot="tabBarExtraContent" v-if="status == 0" @click="handleEdit18">
          批量下单
        </a-button>
      </a-tabs>
    </a-modal>

    <!--待办事项-->
    <!--<backlog ref="model2" ></backlog>-->
  </div>
</template>

<script>
// import Backlog from './model/Backlog.vue'
import NoticeIcon from '@/components/NoticeIcon'
import LangSelect from '@/components/tools/LangSelect'
import { mapActions, mapGetters, mapState } from 'vuex'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AFormItem from 'ant-design-vue/es/form/FormItem'
import moment from 'moment'
// import store from '@/store'  amount-enterprise
export default {
  name: 'UserMenu',
  components: {
    AFormItem,
    ATextarea,
    LangSelect,
    NoticeIcon,
    amountEnterprise: () => import('@/views/tools/amountEnterprise'),
    inquiryMaster: () => import('@/views/tools/inquiryMaster'),
    ToDoList: () => import('@/views/tools/ToDoList'),
    Holdorder: () => import('@/views/tools/Holdorder'),
    CustomerOrders: () => import('@/views/tools/CustomerOrders'),
    NewlyaddedOrderListModel: () => import('@/views/order/modules/NewlyaddedOrderListModel'),
    cuidan: () => import('./model/cuidan'),
    LeChengToken: () => import('./model/leChengToken')
  },
  computed: {
    ...mapGetters(['nickname', 'avatar']),
    ...mapState({
      // 将 store.user.lcStatus 映射到组件的计算属性 lcStatus
      lcStatus: state => state.user.lcStatus,
      cuidanCount: state => state.cuidanCount
    }) // 催单数量
  },
  data() {
    return {
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      customerOrder: '',
      form9: this.$form.createForm(this),
      // *************************************?
      assignStatus: '',
      customerName: '',
      customerMobile: '',
      provinceId: undefined,
      cityId: undefined,
      areaId: undefined,
      OrderStatus: '',
      detailedAddress: '',
      installType: undefined,
      orderType: undefined,
      updateBy: '', // 处理人
      updateTime: null, // 处理时间
      deleteBy: '', // 移除人
      deleteTime: null, // 移除时间
      deleteReason: '', // 移除原因
      createTime: '',
      autoorder: false,
      havework: false,
      provinceMap: [],
      cityMap: [],
      areaArr: [],
      remarkChanges: '',
      selectedRowKeys: [],
      List: [],
      dataList: ['200', '400', '600', '800', '1000', '1500', '2000', '3000', '其他金额'],
      // 标识，初始化默认选中第一项
      clicked: 0,
      current: 0,
      count: '',
      // 支付流程
      steps: [
        {
          title: '填写金额',
          content: 'form-content'
        },
        {
          title: '确认并支付',
          content: 'Second-content'
        },
        {
          title: '完成',
          content: 'Last-content'
        }
      ],
      confirmDirty: false,
      autoCompleteResult: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      formItemLayout1: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 }
        }
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0
          },
          sm: {
            span: 16,
            offset: 8
          }
        }
      },
      // *************************************?
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      form3: this.$form.createForm(this),
      removeData: {},
      // 在岗状态
      workStatus: '',
      // 待办事项数
      todoCount: '',
      // 未派单
      outstandOrderCount: '',
      // 今日处理工单数
      processedOrderCount: '',
      // 订单主键
      nterpriseRechargeId: '',
      // 订单号
      orderNumber: '',
      // 支付方式
      payType: '',
      // 充值金额
      totalAmount: 0,
      // 充值列表
      billingInformation: '',
      // 钱包余额
      totalBalance: '',
      // 企业名称
      enterpriseName: '',
      // 是否为 客服部
      deptId: '',
      // 是否为企业账号
      userType: '',
      finance: '',
      visible1: false,
      visible2: false,
      visible3: false,
      visible4: false,
      visible5: false,
      visible6: false,
      visible7: false,
      visible8: false,
      visible9: false,
      visible10: false,
      visible11: false,
      visible12: false,
      visible13: false,
      data3: [],
      data4: [],
      data5: [],
      data6: [],
      data7: [],
      data12: [],
      data13: [],
      data14: [],
      datalist12: '',
      confirmLoading: false,
      queryParam: {},
      columns3: [
        {
          title: '登录时间',
          dataIndex: 'loginTime',
          align: 'center'
        },
        {
          title: 'IP地址',
          dataIndex: 'ipaddr',
          align: 'center'
        },
        {
          title: '登录地',
          dataIndex: 'loginLocation',
          align: 'center'
        },
        {
          title: '设备',
          dataIndex: 'deviceType',
          align: 'center'
        },
        {
          title: '浏览器',
          dataIndex: 'browser',
          align: 'center'
        },
        {
          title: '操作系统',
          dataIndex: 'os',
          align: 'center'
        }
      ],
      columns4: [
        {
          title: '序号',
          dataIndex: 'num',
          align: 'center'
        },
        {
          title: '技术姓名',
          dataIndex: 'technicalName',
          align: 'center'
        },
        {
          title: '联系方式 ',
          dataIndex: 'phonenumber',
          align: 'center'
        }
      ],
      // 值订单账号
      orderNo: '', // 订单号
      // rechargeId:'',
      // 状态
      status: 0,
      // 支付状态
      payStatus: '',
      // 后台返回的html
      html1: '',
      // 充值时间
      rechargeTime: '',
      columns5: [
        {
          title: ' 操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        },
        {
          title: '充值订单账号',
          dataIndex: 'orderNo',
          align: 'center'
        },
        {
          title: '充值金额',
          dataIndex: 'rechargeMoney',
          align: 'center'
        },
        {
          title: '状态 ',
          dataIndex: 'status',
          align: 'center'
        },
        {
          title: '充值账号 ',
          dataIndex: 'createBy',
          align: 'center'
        },
        {
          title: '充值时间 ',
          dataIndex: 'rechargeTime',
          align: 'center'
        }
      ],
      columns6: [
        {
          title: ' 操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        },
        {
          title: '付款方式',
          dataIndex: 'operType',
          align: 'center'
        },
        {
          title: ' 企业名称',
          dataIndex: 'enterpriseName',
          align: 'center'
        },
        {
          title: '订单号 ',
          dataIndex: 'orderNo',
          align: 'center'
        },
        {
          title: '操作人 ',
          dataIndex: 'createBy',
          align: 'center'
        },
        {
          title: '市场负责人 ',
          dataIndex: 'marketPrincipal',
          align: 'center'
        },
        {
          title: '操作人 ',
          dataIndex: 'phonenumber',
          align: 'center'
        },
        {
          title: '开始时间 ',
          dataIndex: 'StartTime',
          align: 'center'
        },
        {
          title: '结束时间 ',
          dataIndex: 'EndTime',
          align: 'center'
        }
      ],
      columns7: [
        {
          title: '操作',
          width: '80px',
          dataIndex: 'action',

          scopedSlots: { customRender: 'action' }
        },
        {
          title: '文件名',
          dataIndex: 'exportName',
          align: 'center'
        },
        {
          title: ' 下载时长',
          dataIndex: 'exportTime',
          align: 'center'
        },
        {
          title: '下载类型 ',
          width: '160px',
          dataIndex: 'exportType',
          align: 'center'
        },
        {
          title: '下载地址 ',
          dataIndex: 'exportUrl',
          align: 'center'
        }
      ],
      columns12: [
        {
          title: '序号',
          dataIndex: 'no',
          align: 'center'
        },
        {
          title: ' 操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: ' 锁业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
          scopedSlots: { customRender: 'enterpriseName' }
        },
        {
          title: '客户姓名 ',
          dataIndex: 'customerName',
          align: 'center',
          scopedSlots: { customRender: 'customerName' }
        },
        {
          title: '客户联系方式 ',
          dataIndex: 'customerMobile',
          align: 'center',
          scopedSlots: { customRender: 'customerMobile' }
        },
        {
          title: '客户安装地址 ',
          dataIndex: 'address',
          align: 'center',
          scopedSlots: { customRender: 'address' }
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
          scopedSlots: { customRender: 'installType' }
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
          scopedSlots: { customRender: 'orderType' }
        },
        {
          title: '数量',
          dataIndex: 'number',
          align: 'center',
          scopedSlots: { customRender: 'number' }
        },
        {
          title: '客户下单时间',
          dataIndex: 'createTime',
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        }
      ],
      installTypes: [],
      visible19: false,
      rechargeNum: '',
      technicalIdArr: [],
      restaurantOperTypeMap: [],
      restaurantOperType: [],
      restaurantOperTypeMap2: [],
      time: null,
      columns13: [
        {
          title: '序号',
          dataIndex: 'no',
          align: 'center'
        },
        {
          title: ' 订单号',
          dataIndex: 'orderNo',
          align: 'center',
          scopedSlots: { customRender: 'orderNo' }
        },
        {
          title: ' 锁业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
          scopedSlots: { customRender: 'enterpriseName' }
        },
        {
          title: '客户姓名 ',
          dataIndex: 'customerName',
          align: 'center',
          scopedSlots: { customRender: 'customerName' }
        },
        {
          title: '客户联系方式 ',
          dataIndex: 'customerMobile',
          align: 'center',
          scopedSlots: { customRender: 'customerMobile' }
        },
        {
          title: '客户安装地址 ',
          dataIndex: 'address',
          align: 'center',
          scopedSlots: { customRender: 'address' }
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
          scopedSlots: { customRender: 'installType' }
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
          scopedSlots: { customRender: 'orderType' }
        },
        {
          title: '数量',
          dataIndex: 'number',
          align: 'center',
          scopedSlots: { customRender: 'number' }
        },
        {
          title: '客户下单时间',
          dataIndex: 'createTime',
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '处理时间',
          dataIndex: 'updateTime',
          align: 'center',
          scopedSlots: { customRender: 'updateTime' }
        },
        {
          title: '处理人',
          dataIndex: 'updateBy',
          align: 'center',
          scopedSlots: { customRender: 'updateBy' }
        }
      ],
      columns14: [
        {
          title: '序号',
          dataIndex: 'no',
          align: 'center'
        },
        {
          title: ' 操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: ' 锁业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
          scopedSlots: { customRender: 'enterpriseName' }
        },
        {
          title: '客户姓名 ',
          dataIndex: 'customerName',
          align: 'center',
          scopedSlots: { customRender: 'customerName' }
        },
        {
          title: '客户联系方式 ',
          dataIndex: 'customerMobile',
          align: 'center',
          scopedSlots: { customRender: 'customerMobile' }
        },
        {
          title: '客户安装地址 ',
          dataIndex: 'address',
          align: 'center',
          scopedSlots: { customRender: 'address' }
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
          scopedSlots: { customRender: 'installType' }
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
          scopedSlots: { customRender: 'orderType' }
        },
        {
          title: '数量',
          dataIndex: 'number',
          align: 'center',
          scopedSlots: { customRender: 'number' }
        },
        {
          title: '客户下单时间',
          dataIndex: 'createTime',
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '处理时间',
          dataIndex: 'updateTime',
          align: 'center',
          scopedSlots: { customRender: 'updateTime' }
        },
        {
          title: '处理人',
          dataIndex: 'updateBy',
          align: 'center',
          scopedSlots: { customRender: 'updateBy' }
        },
        {
          title: '移除时间',
          dataIndex: 'deleteTime',
          align: 'center',
          scopedSlots: { customRender: 'deleteTime' }
        },
        {
          title: '移除人',
          dataIndex: 'deleteBy',
          align: 'center',
          scopedSlots: { customRender: 'deleteBy' }
        },
        {
          title: '移除原因',
          dataIndex: 'deleteReason',
          align: 'center',
          scopedSlots: { customRender: 'deleteReason' }
        }
      ],
      handleRemoveRecord: '',
      removeStateNum: '',
      beOnDutyIndex: '',
      disGoBackAdd: false,
      createStartTime: null,
      createEndTime: null,
      updateStartTime: null,
      updateEndTime: null, // 处理结束时间
      deleteStartTime: null,
      deleteEndTime: null
    }
  },
  created() {
    // 获取客户下单数量
    this.$store.dispatch('getXiadan')
    this.$axios({
      method: 'get',
      url: '/api/order/reminder/reminderOrderCount',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      this.$store.commit('getCuidanCount', res.data.data)
    })
    this.$axios({
      method: 'post',
      url: '/api/stuff/stuff/getuser',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      console.log('deptId', res)
      this.deptId = res.data.data.deptId
      this.userType = res.data.data.userType
      // console.log(this.deptId)
    })
    this.$axios({
      method: 'get',
      url: '/api/finance/pay/checkIdentification ',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      this.OrderStatus = res.data.data
    })
    // 是否接单/在岗
    this.$axios({
      url: '/api/stuff/stuff/getWorkStatus',
      method: 'get',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      // console.log('res.datasasd',res.data)
      if (res.data.code == 0) {
        if (res.data.data == null) {
          this.havework = false
          this.autoorder = false
        } else {
          if (res.data.data.workStatus == 'WORK_ON') {
            this.havework = true
            console.log('sfdf', this.havework)
          } else {
            this.havework = false
            this.autoorder = false
          }
          if (res.data.data.assignStatus == 'ASSIGN_ON') {
            this.autoorder = true
          } else {
            this.autoorder = false
          }
        }
      }
    })

    // 字典为安装类型

    this.axios({
      url: '/system/dict/data/type',
      method: 'get',
      params: { dictType: 'install_type' }
    }).then(res => {
      const map = new Map()
      // console.log(res)
      res.map(d => {
        map.set(d.dictValue, d.dictLabel)
      })
      // console.log(map)
      this.restaurantOperTypeMap = map
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.installTypes.push({ code: key, label: value })
        // console.log(this.installTypes)
      })
    })
    // 字典为移除原因

    this.axios({
      url: '/system/dict/data/type',
      method: 'get',
      params: { dictType: 'remove_type' }
    }).then(res => {
      const map = new Map()
      // console.log(res)
      res.map(d => {
        map.set(d.dictValue, d.dictLabel)
      })
      // console.log(map)
      this.restaurantOperTypeMap2 = map
      this.restaurantOperTypeMap2.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantOperType.push({ code: key, label: value })
        // console.log(this.restaurantOperType)
      })
    })
    // 获取省
    this.$axios({
      url: '/api/basicdata/province/selectAllProvince',
      method: 'post',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      // console.log(res.data.rows)
      if (res.data.code == 0) {
        this.provinceMap = res.data.rows
      }
    })
  },
  methods: {
    openLeChengModel() {
      this.$refs.leChengToken.init()
    },
    // 立即下单
    goNewlyaddedOrderList() {
      this.$router.push({ name: 'qyCreateOrder' })
      // this.$refs.newlyaddedorderlist.showNewlyaddedOrderList()
      // this.$router.push({name:'NewlyaddedOrderList'})
    },
    moment,
    beOnDuty(e) {
      this.beOnDutyIndex = e
    },
    // 催单列表
    cuidanList() {
      this.$refs.cuidan.init()
    },
    // 自动接单
    autoorders() {
      var ak = ''
      if (this.autoorder == true) {
        ak = 'ASSIGN_NE'
      } else {
        ak = 'ASSIGN_ON'
      }
      console.log('this.autoorder', this.autoorder)
      this.$axios({
        url: '/api/stuff/stuff/stuffassignstatus',
        data: { assignStatus: ak },
        method: 'post',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        // console.log(res.data.rows)
        if (res.data.code == 0) {
          this.$message.success('修改成功')
          this.autoorder = !this.autoorder
        } else {
          this.$message.error('修改失败')
        }
      })
    },
    //
    haveworks() {
      var ak = ''
      if (this.havework == true) {
        ak = 'WORK_NE'
      } else {
        ak = 'WORK_ON'
      }
      console.log('this.autoorder', this.havework)
      this.$axios({
        url: '/api/stuff/stuff/stuffworkstatus',
        data: { workStatus: ak },
        method: 'post',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        if (res.data.code == 0) {
          this.$message.success('修改成功')
          this.havework = !this.havework
          if ((ak = 'WORK_NE')) {
            this.autoorder = false
          }
        } else {
          this.$message.error('修改失败')
        }
      })
    },
    // 重置
    reset() {
      this.orderNo = ''
      this.payStatus = ''
      this.rechargeTime = ''
      this.enterpriseId = this.$store.getters.enterpriseId
      console.log(this.enterpriseId,'enterpriseId----------')
      this.$axios({
        method: 'get',
        url: '/api/finance/refund/get/' + `${this.enterpriseId}`,

        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res.data)
        this.enterpriseName = res.data.data.enterpriseName
        this.totalBalance = res.data.data.totalBalance
        console.log(this.enterpriseName)
        this.$axios({
          method: 'get',
          url: '/api/finance/recharge/list',
          params: {
            enterpriseId: this.enterpriseId
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          console.log(res)
          this.data5 = res.data.rows

          console.log(this.data5)
        })
      })
    },
    onChange1(value, dateString) {
      // console.log('Selected Time2: ', value);
      // console.log('Formatted Selected Time2: ', dateString);
      this.createStartTime = dateString[0]
      this.createEndTime = dateString[1]
    },
    onChange2(value, dateString) {
      // console.log('Selected Time2: ', value);
      // console.log('Formatted Selected Time2: ', dateString);
      this.updateStartTime = dateString[0]
      this.updateEndTime = dateString[1]
    },
    onChange3(value, dateString) {
      // console.log('Selected Time2: ', value);
      // console.log('Formatted Selected Time2: ', dateString);
      this.deleteStartTime = dateString[0]
      this.deleteEndTime = dateString[1]
    },
    timeChange(time, timeString) {
      console.log(time, timeString)
      this.createTime = timeString
    },
    queryList() {
      this.dataListReq(this.status)
    },
    queryKong() {
      ;(this.orderNo = ''),
        (this.updateBy = ''), // 处理人
        (this.updateTime = null), // 处理时间
        (this.deleteBy = ''), // 移除人
        (this.deleteTime = null), // 移除时间
        (this.deleteReason = ''), // 移除原因
        (this.enterpriseName = '')
      this.customerName = ''
      this.customerMobile = ''
      this.form3.setFieldsValue({ provinceId: undefined, cityId: undefined, areaId: undefined })
      // console.log(this.form3.getFieldValue('provinceId'))
      // this.provinceId=undefined
      // this.cityId=undefined
      // this.areaId=undefined
      this.detailedAddress = ''
      this.installType = undefined
      this.orderType = undefined
      this.createTime = undefined
      this.time = null
      ;(this.createStartTime = null),
        (this.createEndTime = null),
        (this.updateStartTime = null),
        (this.updateEndTime = null), // 处理结束时间
        (this.deleteStartTime = null),
        (this.deleteEndTime = null)
    },
    // 导出
    xiadanExcept() {
      this.$axios({
        method: 'get',
        url: '/api/order/customer/export',
        params: {
          enterpriseName: this.enterpriseName,
          customerName: this.customerName,
          customerMobile: this.customerMobile,
          provinceId: this.provinceId,
          cityId: this.cityId,
          areaId: this.areaId,
          detailedAddress: this.detailedAddress,
          installType: this.installType,
          orderType: this.orderType,
          createTime: this.createTime,
          status: this.status
        },
        responseType: 'arraybuffer',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }).then(res => {
        console.log(res)
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'
        })
        const a = document.createElement('a')
        // 生成文件路径
        const href = window.URL.createObjectURL(blob)
        a.href = href
        const fileName = '客户下单'
        // 文件名中有中文 则对文件名进行转码
        a.download = decodeURIComponent(fileName)
        // 利用a标签做下载
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(href)
      })
    },
    dataListReq(status) {
      if (status == 0) {
        this.$axios({
          method: 'get',
          url: '/api/order/customer/selectOrderList',
          params: {
            enterpriseName: this.enterpriseName,
            customerName: this.customerName,
            customerMobile: this.customerMobile,
            provinceId: this.form3.getFieldValue('provinceId'),
            cityId: this.form3.getFieldValue('cityId'),
            areaId: this.form3.getFieldValue('areaId'),
            detailedAddress: this.detailedAddress,
            installType: this.installType,
            orderType: this.orderType,
            createStartTime: this.createStartTime,
            createEndTime: this.createEndTime,
            status: status
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          console.log(res.data)
          this.data12 = res.data.rows
          this.datalist12 = res.data.rows.length
          console.log(this.datalist12)
        })
      } else if (status == 1) {
        this.$axios({
          method: 'get',
          url: '/api/order/customer/selectOrderList',
          params: {
            orderNo: this.orderNo,
            updateBy: this.updateBy,
            createStartTime: this.createStartTime,
            createEndTime: this.createEndTime,
            updateStartTime: this.updateStartTime,
            updateEndTime: this.updateEndTime,
            enterpriseName: this.enterpriseName,
            customerName: this.customerName,
            customerMobile: this.customerMobile,
            provinceId: this.form3.getFieldValue('provinceId'),
            cityId: this.form3.getFieldValue('cityId'),
            areaId: this.form3.getFieldValue('areaId'),
            detailedAddress: this.detailedAddress,
            installType: this.installType,
            orderType: this.orderType,
            status: status
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          console.log(res.data)
          this.data13 = res.data.rows
        })
      } else if (status == 2) {
        this.$axios({
          method: 'get',
          url: '/api/order/customer/selectOrderList',
          params: {
            updateBy: this.updateBy,
            createStartTime: this.createStartTime,
            createEndTime: this.createEndTime,
            updateStartTime: this.updateStartTime,
            updateEndTime: this.updateEndTime,
            deleteStartTime: this.deleteStartTime,
            deleteEndTime: this.deleteEndTime,
            deleteBy: this.deleteBy,
            deleteReason: this.deleteReason,
            enterpriseName: this.enterpriseName,
            customerName: this.customerName,
            customerMobile: this.customerMobile,
            provinceId: this.form3.getFieldValue('provinceId'),
            cityId: this.form3.getFieldValue('cityId'),
            areaId: this.form3.getFieldValue('areaId'),
            detailedAddress: this.detailedAddress,
            installType: this.installType,
            orderType: this.orderType,
            status: status
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          console.log(res.data)
          this.data14 = res.data.rows
        })
      }
    },
    changeTabs(e) {
      this.queryKong()
      this.status = e - 1
      this.dataListReq(this.status)
    },
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    handleEdit18() {
      console.log(this.data12)
      var array = []
      for (var i = 0; i < this.selectedRowKeys.length; i++) {
        array[i] = this.data12[this.selectedRowKeys[i]].id
      }
      console.log(array)
      if (array.length != 0) {
        this.$axios({
          method: 'post',
          url: '/api/order/customer/sendOrder',
          data: array,
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          console.log(res)
          if (res.data.code == 0) {
            this.$message.success('下单成功')
            this.dataListReq(this.status)
            this.selectedRowKeys = []
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        this.$message.error('请选择订单')
      }
    },
    removeState(e) {
      console.log(e)
      this.removeStateNum = e
    },
    handleAdd14(record) {
      console.log(record)
      this.$axios({
        method: 'get',
        url: '/api/order/customer/recoverOrder?id=' + record.id,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res.data)
        if (res.data.code == 0) {
          this.$message.success('恢复成功')
          this.dataListReq(this.status)
        }
      })
    },
    // 我的下载清空
    query2() {
      var userId = this.$store.getters.userId
      this.$axios({
        method: 'get',
        url: '/api/stuff/record/clearExportRecord',
        params: {
          userId: userId
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res.data)
        if (res.data.code == 0) {
          this.$message.success('清空成功')
          var userId = this.$store.getters.userId
          console.log(userId)
          this.$axios({
            method: 'get',
            url: '/api/stuff/record/list',
            params: {
              userId: userId
            },
            headers: {
              token: Vue.ls.get(ACCESS_TOKEN),
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(res => {
            console.log(res.data)
            this.data7 = res.data.rows
            for (var i = 0; i < this.data7.length; i++) {
              if (this.data7[i].exportType == 0) {
                this.data7[i].exportType = '表格'
              } else if (this.data7[i].exportType == 1) {
                this.data7[i].exportType = '图片'
              }
            }
          })
        } else if (res.data.code == 500) {
          this.$message.success('暂无数据')
        }
      })
    },

    handleSubmit10() {
      this.visible11 = false
    },
    // 我的下载
    Downloads() {
      this.visible11 = true

      var userId = this.$store.getters.userId
      console.log(userId)
      this.$axios({
        method: 'get',
        url: '/api/stuff/record/list',
        params: {
          userId: userId
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res.data)
        this.data7 = res.data.rows
        for (var i = 0; i < this.data7.length; i++) {
          if (this.data7[i].exportType == 0) {
            this.data7[i].exportType = '表格'
          } else if (this.data7[i].exportType == 1) {
            this.data7[i].exportType = '图片'
          }
        }
      })
    },

    handleEdit23(record) {
      console.log('record', record)
      window.open(
        process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          record.exportUrl +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      )
      // console.log("record",record)
      // // var str=process.env.VUE_APP_API_BASE_URL + '/stock/storageAccessory/storageExport?pageNum=1&pageSize=10'
      // var str=process.env.VUE_APP_API_BASE_URL + '/stuff' + record.exportUrl
      // // for(let i in this.queryParam ){
      // //   if(this.queryParam[i]!=undefined){
      // //     str=str+'&'+i+'='+this.queryParam[i]
      // //   }
      // // }
      // str=str+'&token='+this.headers.token
      // window.open(str)
    },

    handleEdit12(record) {
      this.$axios({
        method: 'post',
        url: '/api/order/customer/sendOrder',
        data: [record.id],
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res)
        if (res.data.code == 0) {
          this.$message.success('下单成功')
          this.dataListReq(this.status)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    handleRemove12(record) {
      this.visible13 = true
      this.handleRemoveRecord = record.id
    },
    remarkChange(e) {
      // console.log(e)
      // this.remarkChanges=e.data
    },
    handleSubmit13() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          console.log('Received values of form: ', values)
          this.$axios({
            method: 'post',
            url: '/api/order/customer/removeOrder',
            data: {
              id: this.handleRemoveRecord,
              deleteReason: values.status,
              remark: values.remark ? values.remark : this.remarkChanges
            },
            headers: {
              token: Vue.ls.get(ACCESS_TOKEN),
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(res => {
            console.log(res)
            if (res.data.code == 0) {
              this.$message.success('移除成功')
              this.visible13 = false
              this.confirmLoading = false
              this.dataListReq(this.status)
            }
          })
        }
      })
    },
    // 客户下单
    CustomerOrders() {
      this.visible12 = true
      this.status = 0
      this.queryKong()
      ;(this.selectedRowKeys = []),
        this.$axios({
          method: 'get',
          url: '/api/order/customer/selectOrderList',
          params: {
            enterpriseId: '',
            customerName: '',
            customerMobile: '',
            provinceId: '',
            cityId: '',
            areaId: '',
            detailedAddress: '',
            installType: '',
            orderType: '',
            createTime: '',
            status: this.status
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          console.log(res.data)
          this.data12 = res.data.rows
          this.datalist12 = res.data.rows.length
        })
    },
    installChange(e) {
      this.installType = e
      this.List = []
      this.orderType = undefined
      this.$axios({
        method: 'get',
        url: '/api/basicdata/orderType/getList/' + e,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res)
        if (res.data.code == 0) {
          this.List = res.data.rows
          console.log(res.data.rows)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    orderTypeChange(e) {
      console.log(e)
      this.orderType = e
    },
    changeProvince(e) {
      this.cityMap = []
      this.areaArr = []
      this.form3.setFieldsValue({ cityId: undefined, areaId: undefined })
      this.detailedAddress = ''
      // 市
      this.province = { provinceCode: e }
      this.provinceId = e
      this.$axios({
        method: 'post',
        url: '/api/basicdata/city/selectCityName',
        data: this.province
      }).then(res => {
        console.log(res.data.rows)
        this.cityMap = res.data.rows
      })
    },
    changeCity(e) {
      this.areaArr = []
      this.form3.setFieldsValue({ areaId: undefined })
      this.detailedAddress = ''
      // 区
      this.city = { cityCode: e }
      this.cityId = e
      this.$axios({
        method: 'post',
        url: '/api/basicdata/area/selectAreaName',
        data: this.city
      }).then(res => {
        console.log(res.data.rows)
        this.areaArr = res.data.rows
      })
    },
    changeArea(e) {
      this.areaCode = e
      this.areaId = e
      this.detailedAddress = ''
    },
    // 支付方式
    // onChange(value) {
    //   console.log(value)
    //   this.payType = value
    // },
    openNewWindow(lis) {
      this.$nextTick(() => {
        const divForm = document.getElementsByTagName('divform')
        if (divForm.length) {
          document.body.removeChild(divForm[0])
        }
        const div = document.createElement('divform')
        div.innerHTML = lis // data就是接口返回的form 表单字符串
        document.body.appendChild(div)
        document.forms[0].setAttribute('target', '_blank') // 新开窗口跳转
        document.forms[0].submit()
      })

      // this.$nextTick(()=> {
      //   // window.open()
      //   const div1=document.createElement('divform1');
      //   let divForm1 = document.getElementsByTagName('divform1')
      //   if (divForm1.length) {
      //     document.body.removeChild(divForm1[0])
      //   }
      //   alert(this.html1)
      //   div1.innerHTML=lis; // data就是接口返回的form 表单字符串
      //   document.body.appendChild(div1);
      //   document.forms[0].setAttribute('target', '_blank') // 新开窗口跳转
      //   document.forms[0].submit();
      // })
    },
    handleSubmit12() {
      this.visible12 = false
    },
    next(value) {
      let num = 0
      this.rechargeNum = 0
      if (this.totalAmount != 0) {
        if (this.current == 0) {
          this.current++
          num = 1
        } else if (this.current == 1) {
          num = 2
        }
      } else {
        this.$message.error('请选择或输入金额')
      }
      console.log(this.current, this.rechargeNum, value)
      // if(this.rechargeNum == 0){
      if (num == 2) {
        if (this.payType != '') {
          // console.log(this.$store.getters.enterpriseId)
          // console.log(this.payType,'jinru ')
          var enterpriseId = this.$store.getters.enterpriseId
          this.$axios({
            method: 'post',
            url: '/api/finance/pay/insert',
            data: {
              enterpriseId: enterpriseId,
              totalAmount: this.totalAmount,
              payType: this.payType
            },
            headers: {
              token: Vue.ls.get(ACCESS_TOKEN),
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(res => {
            console.log(res)
            this.orderNumber = res.data.data
            if (this.payType == 2) {
              this.$axios({
                method: 'get',
                url: '/api/finance/pay/pay',
                params: {
                  rechargeId: res.data.data,
                  totalAmount: this.totalAmount
                },
                headers: {
                  token: Vue.ls.get(ACCESS_TOKEN),
                  'Content-Type': 'application/json;charset=UTF-8'
                }
              }).then(res => {
                console.log(res.data.data)
                this.html1 = res.data.data
                this.openNewWindow(this.html1)
                const that = this
                this.$confirm({
                  title: '支付',
                  content: '请在新打开的页面进行支付',
                  okType: 'danger',
                  onOk() {
                    that.current++
                  },
                  onCancel() {
                    console.log('Cancel')
                  }
                })
                // this.$nextTick(()=> {
                //   let divForm = document.getElementsByTagName('divform')
                //   if (divForm.length) {
                //     document.body.removeChild(divForm[0])
                //   }
                //   const div=document.createElement('divform');
                //   div.innerHTML=this.html1; // data就是接口返回的form 表单字符串
                //   document.body.appendChild(div);
                //   document.forms[0].setAttribute('target', '_blank') // 新开窗口跳转
                //   document.forms[0].submit();
                // })
                this.$axios({
                  method: 'get',
                  url: '/api/finance/pay/delayed',
                  params: {
                    tradeNo: this.orderNumber
                  },
                  headers: {
                    token: Vue.ls.get(ACCESS_TOKEN),
                    'Content-Type': 'application/json;charset=UTF-8'
                  }
                })
              })
            } else {
              this.current++
            }
          })
        } else {
          this.$message.error('请选择支付方式！')
        }
      }
      // }
      if (this.current == 2) {
        this.visible6 = false
      }
    },
    // 账户信息
    information() {
      this.visible5 = true
      console.log(this.$store.getters.nickname + 'ccc')
      console.log(this.$store.getters.enterpriseId)
      var enterpriseId = this.$store.getters.enterpriseId
      this.$axios({
        method: 'get',
        url: '/api/finance/refund/get/' + `${enterpriseId}`,

        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res.data)
        this.enterpriseName = res.data.data.enterpriseName
        this.totalBalance = res.data.data.totalBalance
        console.log(this.enterpriseName)
      })
    },
    // 账户信息 确认
    handleSubmit5() {
      this.visible5 = false
    },

    // 在线充值
    information2() {
      this.totalAmount = 0.0
      this.visible6 = true
      this.rechargeNum = 0
      this.payType = ''
      this.current = 0
      var enterpriseId = this.$store.getters.enterpriseId
      this.$axios({
        method: 'get',
        url: '/api/finance/refund/get/' + `${enterpriseId}`,

        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res.data)
        this.enterpriseName = res.data.data.enterpriseName
        this.totalBalance = res.data.data.totalBalance
        console.log(this.enterpriseName)
      })
    },
    // 选择金额
    changeTab(index) {
      this.clicked = index
      if (this.clicked == 0) {
        this.visible9 = false
        this.totalAmount = 200.0
      } else if (this.clicked == 1) {
        this.visible9 = false
        this.totalAmount = 400.0
      } else if (this.clicked == 2) {
        this.visible9 = false
        this.totalAmount = 600.0
      } else if (this.clicked == 3) {
        this.visible9 = false
        this.totalAmount = 800.0
      } else if (this.clicked == 4) {
        this.visible9 = false
        this.totalAmount = 1000.0
      } else if (this.clicked == 5) {
        this.visible9 = false
        this.totalAmount = 1500.0
      } else if (this.clicked == 6) {
        this.visible9 = false
        this.totalAmount = 2000.0
      } else if (this.clicked == 7) {
        this.visible9 = false
        this.totalAmount = 3000.0
      } else if (this.clicked == 8) {
        this.visible9 = true
        this.totalAmount = 0.0
      } else {
        this.visible9 = false
      }
    },
    // 在线充值 确认
    handleSubmit6() {
      this.visible6 = false
    },
    // 充值列表
    information3() {
      this.visible7 = true
      this.enterpriseId = this.$store.getters.enterpriseId
      // console.log(this.enterpriseId)
      this.$axios({
        method: 'get',
        url: '/api/finance/recharge/list/',
        params: {
          orderNo: null,
          enterpriseId: this.enterpriseId,
          rechargeTime: null,
          status: null
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res.data.rows)
        this.data5 = res.data.rows
        this.enterpriseName = res.data.data.enterpriseName
        this.totalBalance = res.data.data.totalBalance
        console.log(this.enterpriseName)
        this.$axios({
          method: 'get',
          url: '/api/finance/recharge/list',
          params: {
            enterpriseId: this.enterpriseId
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          console.log(res)
          this.data5 = res.data.rows

          console.log(this.data5)
        })
      })
    },
    // 支付
    handleEdit2(record) {
      console.log(record)
      this.visible7 = false
      this.visible6 = true
      this.rechargeNum = 1
      this.totalAmount = record.rechargeMoney
      this.enterpriseName = this.enterpriseName
      this.orderNumber = record.orderNo
      this.orderNo = record.orderNo
      this.current = 1
      this.payType = 2
      this.$axios({
        method: 'get',
        url: '/api/finance/pay/pay',
        params: {
          rechargeId: this.orderNo,
          totalAmount: this.totalAmount
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res.data.data)
        this.html1 = res.data.data
        this.openNewWindow(this.html1)
        const that = this
        this.$confirm({
          title: '支付',
          content: '请在新打开的页面进行支付',
          okType: 'danger',
          onOk() {
            that.current++
          },
          onCancel() {
            console.log('Cancel')
          }
        })

        // this.$nextTick(()=> {
        //   let divForm = document.getElementsByTagName('divform')
        //   if (divForm.length) {
        //     document.body.removeChild(divForm[0])
        //   }
        //   const div=document.createElement('divform');
        //   div.innerHTML=this.html1; // data就是接口返回的form 表单字符串
        //   document.body.appendChild(div);
        //   document.forms[0].setAttribute('target', '_blank') // 新开窗口跳转
        //   document.forms[0].submit();
        // })
        this.$axios({
          method: 'get',
          url: '/api/finance/pay/delayed',
          params: {
            tradeNo: this.orderNumber
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        })
      })
    },
    // 删除
    handleEdit3(record) {
      this.nterpriseRechargeId = record.enterpriseRechargeId
      this.$axios({
        method: 'post',
        url: '/api/finance/recharge/delete',
        data: {
          enterpriseRechargeId: this.nterpriseRechargeId,
          enterpriseId: this.enterpriseId
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res)
        if (res.data.code == 0) {
          this.$message.success('删除成功')
        } else {
          this.$message.success('删除失败')
        }

        console.log(this.data5)
      })
    },
    // 查询
    query() {
      this.$axios({
        method: 'get',
        url: '/api/finance/recharge/list',
        params: {
          orderNo: this.orderNo,
          status: this.payStatus,
          rechargeTime: this.rechargeTime
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res)
        this.data5 = res.data.rows

        console.log(this.data5)
      })
    },
    // 在线充值 确认
    handleSubmit7() {
      this.visible7 = false
    },
    // 账单
    async information4() {
      this.enterpriseId = this.$store.getters.enterpriseId
      this.visible8 = true
      await this.$axios({
        method: 'get',
        url: '/api/finance/detailed/list',
        params: {
          enterpriseId: '795e9315fcbe11eab85cfa163e4d2679'
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res)
        this.data6 = res.data.rows[0].enterpriseDetailed

        console.log(this.data5)
      })
    },
    // 账单 确认
    handleSubmit8() {
      this.visible8 = false
    },
    // 时间
    onChangeDate(time, timeString) {
      this.rechargeTime = timeString
      console.log(time, timeString)
    },
    // 修改密码
    handleConfirmBlur(e) {
      const value = e.target.value
      console.log(value)
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword(rule, value, callback) {
      // console.log(rule, value, callback)
      const form = this.form
      if (value && value !== form.getFieldValue('newPwd')) {
        callback('两次密码不一致!')
      } else {
        callback()
      }
    },
    checkPwd(rule, value, callback) {
      const form = this.form
      // const pwdRegex = new RegExp('^[a-zA-Z0-9_-]{6,20}$')
      const pwdRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,64}$/
      if (!pwdRegex.test(value) && value) {
        callback(new Error('请输入8位以上密码，必须包含数字、字母、英文特殊字符'))
      } else if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true })
      } else {
        callback()
      }
    },
    // validateToNextPassword(rule, value, callback) {
    //   const form = this.form;
    //   if (value && this.confirmDirty) {
    //     form.validateFields(['confirm'], { force: true });
    //   }
    //   callback();
    // },
    // ************************************************
    handleSubmit2(e) {
      e.preventDefault()
      const that = this
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          // console.log('Received values of form: ', values);
          this.$axios({
            method: 'post',
            url: '/api/system/user/resetpwd',
            data: {
              oldPwd: values.oldPwd,
              newPwd: values.newPwd
            },
            headers: {
              token: Vue.ls.get(ACCESS_TOKEN),
              'Content-Type': 'application/json;charset=UTF-8'
            }
          })
            .then(res => {
              console.log(res)
              if (res.data.code === 0) {
                that.$message.success('密码修改成功')
                that.visible2 = false
                this.Logout({})
                  .then(() => {
                    setTimeout(() => {
                      window.location.reload()
                    }, 16)
                  })
                  .catch(err => {
                    this.$message.error({
                      title: '错误',
                      description: err.message
                    })
                  })
              } else if (res.data.code == 1) {
                that.$message.error('原始密码错误！')
              }
            })
            .catch(() => {
              that.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
    // ***************************************************

    ...mapActions(['Logout']),
    // 用户信息
    handleUserinfo() {
      this.visible1 = true
      this.$axios({
        method: 'post',
        url: '/api/stuff/stuff/getuser',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res.data)
        this.queryParam = res.data.data
        console.log(this.queryParam)
      })
    },
    handleEdit() {
      this.visible2 = true
      this.form.resetFields()
    },
    // 最近登录
    handleLogin() {
      this.visible3 = true
      this.$axios({
        method: 'post',
        url: '/api/stuff/stuff/logininfo',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res.data.rows)
        this.data3 = res.data.rows
      })
    },
    // 刷新值班技术列表
    dataDuty() {
      this.$axios({
        method: 'get',
        url: '/api/stuff/technical/getSupportWorkNo',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        this.data4 = res.data.rows
      })
    },
    // 值班信息
    handleMessage() {
      this.$axios({
        method: 'post',
        url: '/api/stuff/stuff/getuser',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        this.queryParam = res.data.data
        const roleIdsArr = this.queryParam.roleIds.split(',')
        for (let i = 0; i < roleIdsArr.length; i++) {
          if (roleIdsArr[i] == 29) {
            this.disGoBackAdd = true
          }
        }
      })
      this.visible4 = true
      this.dataDuty()
      this.$axios({
        method: 'get',
        url: '/api/stuff/technical/getTechnicalList',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        this.$nextTick(() => {
          this.technicalIdArr = res.data.rows
        })
      })
      // technicalIdArr
    },
    goBack1() {
      this.visible1 = false
    },
    goBack2() {
      this.visible2 = false
    },
    goBack3() {
      this.visible3 = false
    },
    goBack4() {
      this.visible4 = false
    },
    goBackAdd() {
      this.visible19 = true
      // this.form9.resetFields()
      const arr = []
      if (this.data4.length != 0) {
        for (let i = 0; i < this.data4.length; i++) {
          arr.push(this.data4[i].technicalId)
        }
      }
      console.log(arr, 'technicalIdArr')
      this.$nextTick(() => {
        this.form9.setFieldsValue({
          technicalId: arr
        })
      })
    },
    // 注销
    handleLogout() {
      this.visible10 = true
      this.$axios({
        method: 'post',
        url: '/api/stuff/stuff/stuffexitmsg',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        // console.log(res.data);
        // this.data7 = res.data

        if (res.data.data.workStatus == 'WORK_ON') {
          this.workStatus = '在岗'
        } else {
          this.workStatus = '离岗'
        }
        // console.log(this.workStatus)
        this.outstandOrderCount = res.data.data.outstandOrderCount
        this.processedOrderCount = res.data.data.processedOrderCount
      })
      this.$axios({
        method: 'get',
        url: '/api/backlog/union/count',
        params: {},
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        // console.log(res)
        this.todoCount = res.data.data.unProcessIdNum
      })
    },
    handleSubmit11() {
      this.form9.validateFields((err, values) => {
        const arr = []
        if (values.technicalId == undefined) {
        } else {
          for (let i = 0; i < values.technicalId.length; i++) {
            for (let s = 0; s < this.technicalIdArr.length; s++) {
              if (values.technicalId[i] == this.technicalIdArr[s].technicalId) {
                arr.push(this.technicalIdArr[s])
              }
            }
          }
        }
        this.$axios({
          method: 'post',
          url: '/api/stuff/technical/save',
          data: arr,
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.$message.success('新增成功')
            this.dataDuty()
            this.visible19 = false
          } else {
            this.$message.error(res.data.message)
          }
        })
      })
    },
    handleSubmit9() {
      var that = this
      this.Logout({})
        .then(() => {
          setTimeout(() => {
            // that.$router.push({name:'loginLogList'})
            that.$router.push({ path: '/user/login' })
          }, 16)
        })
        .catch(err => {
          this.$message.error({
            title: '错误',
            description: err.message
          })
        })
    }
  }
}
</script>

<style>
.bor {
  border: 2px solid black;
}
</style>
<style scoped>
.ant-switch {
  width: 80px;
  height: 30px !important;
  margin-right: 20px !important;
}

.ant-switch:after {
  width: 20px !important;
  height: 20px !important;
  top: 3px !important;
}

/deep/.ant-badge {
  padding-right: 20px !important;
}

/deep/.ant-badge-count {
  height: 16px;
  border-radius: 8px;
  min-width: 16px;
  background: #f5222d;
  color: #fff;
  line-height: 16px;
  text-align: center;
  font-size: 10px;
  right: 20px;
}
</style>
